import {BackendOrderManager} from 'components/Backend/Order/Manager';

export const orderNum = 6;
// export const title = '訂單查詢';

export default BackendOrderManager;
